import ImgProfLive from 'assets/images/content/berufstaetigkeit.jpg'
import ImgRelationships from 'assets/images/content/beziehungen.jpg'
import ImgHealth from 'assets/images/content/gesundheit_balance.jpg'
import ImgIdentity from 'assets/images/content/identitaet.jpg'
import ImgCrisis from 'assets/images/content/krisenzeiten_2.jpg'
import ImgSelfDeterm from 'assets/images/content/selbstbestimmung.jpg'
import {
  Button, Card, CardContent, Col, CollapsibleTopicItem, Container, Row, Section,
  ShareButtons,
} from 'atoms'
import { ContactCard } from 'organisms'
import { FC } from 'react'

import {
  CollapsibleContentCrisis, CollapsibleContentHealthBalance,
  CollapsibleContentIdentity, CollapsibleContentProfessionalLife,
  CollapsibleContentRelationships, CollapsibleContentSelfDetermination,
} from './CollapsibleContent'
import ContactButton from './ContactButton'

const AngebotePrivatpersonen: FC<unknown> = () => (
  <>
    <Section background="vintage">
      <Container>
        <h1>
          Coaching von Frau zu Frau
        </h1>
        <h2 className="sub-headline text-center mb-5">
          Angebote für Privatpersonen
        </h2>
        <Row>
          <Col xs={12} lg={6}>
            <CollapsibleTopicItem
              groupId="privpers"
              key="identity"
              id="identity"
              label="Identität"
              labelAs="h2"
              labelImage={ImgIdentity}
              content={<CollapsibleContentIdentity />}
            />
            <CollapsibleTopicItem
              groupId="privpers"
              key="relationships"
              id="relationships"
              label="Beziehungen"
              labelAs="h2"
              labelImage={ImgRelationships}
              content={<CollapsibleContentRelationships />}
            />
            <CollapsibleTopicItem
              groupId="privpers"
              key="health"
              id="health"
              label="Gesundheit und Balance"
              labelAs="h2"
              labelImage={ImgHealth}
              content={<CollapsibleContentHealthBalance />}
            />
          </Col>
          <Col xs={12} lg={6}>
            <CollapsibleTopicItem
              groupId="privpers"
              key="selfDeterm"
              id="selfDeterm"
              label="Selbstbestimmung"
              labelAs="h2"
              labelImage={ImgSelfDeterm}
              content={<CollapsibleContentSelfDetermination />}
            />
            <CollapsibleTopicItem
              groupId="privpers"
              key="profLive"
              id="profLive"
              label="Berufstätigkeit"
              labelAs="h2"
              labelImage={ImgProfLive}
              content={<CollapsibleContentProfessionalLife />}
            />
            <CollapsibleTopicItem
              groupId="privpers"
              key="crisis"
              id="crisis"
              label="Krisenzeiten"
              labelAs="h2"
              labelImage={ImgCrisis}
              content={<CollapsibleContentCrisis />}
            />
          </Col>
        </Row>
      </Container>
    </Section>
    <Section>
      <Container>
        <Row className="justify-content-center">
          <Col xl={6} className="my-4">
            <p className="text-center text-highlight">
              {`Haben Sie etwas entdeckt, was Sie anspricht? Wenn ja, kontaktieren Sie mich. Oder brennt Ihnen etwas anderes auf der Seele? Ich bin gern für Sie da, nehmen Sie Kontakt zu mir auf.`}
            </p>
            <div className="text-center">
              <ContactButton theme="green">
                Kontakt aufnehmen
              </ContactButton>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col xs={12} md={4}>
            <h3 className="text-center">
              Kein Risiko!
            </h3>
            <p>
              {`Bei unserem ersten Gespräch lernen wir uns kennen und klären alle offenen Fragen. Sie haben die Gelegenheit, sich von der Richtigkeit ihrer Entscheidung zu überzeugen. Sie gehen kein Risiko ein. Es entstehen keine Kosten für Sie.`}
            </p>
          </Col>
          <Col xs={12} md={4}>
            <h3 className="text-center">
              Diesen Weg gehen wir gemeinsam!
            </h3>
            <p>
              {`Sie bestimmen die Themen unserer Gespräche, deren Gewichtung und das Tempo. Klar ist: es geht um Ihre Bedürfnisse und Wünsche!`}
            </p>
            <div className="text-center my-4 d-none d-md-block">
              <ContactButton theme="link">
                Ich mache das jetzt!
              </ContactButton>
            </div>
          </Col>
          <Col xs={12} md={4}>
            <h3 className="text-center">
              Ihre Vorteile
            </h3>
            <p>
              {`Ihnen sagt niemand mehr, wo es lang geht. Sie kennen und bestimmen Ihren Weg selbst. Stolpersteine nutzen Sie als Brücken. Sie finden Ihre persönliche Balance. Krisen werfen sie nicht aus der Bahn. Und ganz nebenbei spüren sie Zufriedenheit und Zuversicht.`}
            </p>
          </Col>
        </Row>
        <div className="text-center my-4 d-md-none">
          <ContactButton>
            Ich mache das jetzt!
          </ContactButton>
        </div>
      </Container>
    </Section>
    <Section background="vintage">
      <Container>
        <Card>
          <CardContent className="py-4 px-4">
            <Row className="align-items-stretch">
              <Col sm={12} md={5} className="text-center text-md-end">
                <h4>Wir treffen uns in meinem Büro in Berlin Mitte</h4>
                <p>
                  {`Sie bevorzugen eine neutrale Umgebung und möchten sich von Angesicht zu Angesicht unterhalten?`}
                </p>
              </Col>
              <Col sm={12} md={2} className={`text-center d-flex align-items-center justify-content-center py-4`}>
                <em>oder</em>
              </Col>
              <Col sm={12} md={5} className="text-center text-md-start">
                <h4>Wir unterhalten uns per Telefon / Skype / Zoom</h4>
                <p>
                  {`Sie mögen es anonym und möchten von einem Ort Ihrer Wahl - Ihrer Wohlfühlumgebung - aus sprechen?`}
                </p>
              </Col>
            </Row>
            <hr className="my-4 d-md-none" />
            <div className="text-center">
              <ContactButton>
                Ganz ohne Risiko mehr erfahren
              </ContactButton>
            </div>
          </CardContent>
        </Card>
        <Card className="mt-4">
          <CardContent className="py-5 px-4 text-center">
            <h2 className="mt-2">Online-Akademie Lebensart</h2>
            <p>
              {`Lernen Sie lieber noch unabhängiger von Zeit und Raum? Dann nutzen Sie gern meine neuen Online-Kursangebote der LebensArt-Akademie. Einfach machen.`}
            </p>
            <Button type="link" theme="blue" href="/lebensart-akademie">
              Zu den Onlinekursen - Lebensart Akademie
            </Button>
          </CardContent>
        </Card>
        <ContactCard className="mt-4" />
      </Container>
    </Section>
    <Section>
      <Container>
        <ShareButtons className="d-none d-md-block" full />
        <ShareButtons className="d-block d-md-none" full size={40} />
      </Container>
    </Section>
  </>
)

export default AngebotePrivatpersonen
